import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
// import { MatFormFieldModule } from '@angular/material/form-field-module.d';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
// import { MatPaginator } from '@angular/material/paginator.d';
import { MatSort, MatSortModule } from '@angular/material/sort';
// import { MatSort } from '@angular/material/sor';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { RouterLink, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { HeaderStyleOneComponent } from 'src/app/components/common/header-style-one/header-style-one.component';
import { Apiservice } from 'src/app/services/apiservice';
import Swal from 'sweetalert2';
import { Registrationform } from '../registrationform/registrationform';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-notifications',
  imports: [MatTableModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, MatSortModule, CommonModule, FormsModule, NgSelectModule],
  templateUrl: './notifications.html',
  styleUrl: './notifications.scss'
})
export class Notifications {
  headerclass = {
    // 'fontSize.px': 17,
    'fontWeight': 'bold',
    'background': '#BA4D13',
    'color': '#fff',
    'text-align': 'center',
    // 'padding': '8px',
  };
  filteredData: any[] = [];   // Filtered data based on search
  searchTerm: string = '';    // Search term
  sortColumn: string = '';   // Column to sort by
  sortDirection: 'asc' | 'desc' = 'asc';  // Sort direction
  @ViewChild(MatPaginator) paginator: MatPaginator;      // Mat Table Pagination selector
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('firstTableSort') public firstTableSort: MatSort;                     // Mat Table Sorting selector
  // 'vacancies',
  // 'age_limit', 'salary',
  displayedColumns: string[] = ['i', 'district_name', 'mela_date', 'mela_name', 'action'];
  dataSource: MatTableDataSource<any>;
  results_notifications_list: any = [];
  serch: any;
  jobsScrollData: any = [
    {
      "message": "MEPMA-NIPUNA JOB MELA 2025"
    }]

  districtData: any = [];
  showloader: any;
  melanotifcations: any = []
  constructor(private router: Router, private api: Apiservice,) { }

  ngOnInit(): void {
    this.getMelaNotifications();
    // this.getJobslist();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getMelaNotifications() {
    this.showloader = true;
    this.api.getMelaNotifications().subscribe((res: any) => {
      if (res.status === 200) {
        this.melanotifcations = res.data;
        console.log(this.melanotifcations);
        this.showloader = false;
        console.log(res.data);
        res.data.map(((respo, index) => {
          respo.i = index + 1;
        }))

        // this.arrayData = res.data;
        this.showloader = false;
        this.dataSource = new MatTableDataSource(res.data);
        console.log(this.dataSource);
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }, 500);
      }
    },
      (err) => {
        this.showloader = false;
        console.error('API error:', err);
      });
  }

  // navigteApplyForm(row) {
  //   // console.log(row);
  //   // Swal.fire({
  //   //   icon: 'info',
  //   //   title: 'Coming Soon',
  //   //   text: 'This feature will be available soon. Stay tuned!',
  //   //   confirmButtonText: 'OK'
  //   // });
  //   let access_token = localStorage.getItem('access_token');
  //   if (access_token) {
  //     this.showloader = true;
  //     this.api.getUserprofileData().subscribe((res: any) => {
  //       // console.log(res);
  //       this.showloader = false;
  //       if (res.status == 200) {
  //         let user = res.data[0];
  //         if (user.registration_status != 0) {
  //           console.log(row);
  //           this.router.navigate(['/applycompanies'], {
  //             queryParams: {
  //               reqId: row.mela_reqId ?? row.reqId
  //             }
  //           });
  //         } else {
  //           Swal.fire({
  //             title: 'Incomplete Registration',
  //             text: 'You must complete your registration before viewing your profile. Do you want to complete it now?',
  //             icon: 'warning',
  //             showCancelButton: true,
  //             confirmButtonText: 'Yes, complete now',
  //             cancelButtonText: 'No, later',
  //             confirmButtonColor: '#3085d6',
  //             cancelButtonColor: '#d33'
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.router.navigateByUrl('/registration');
  //             } else {
  //               console.log('User chose not to register now.');
  //             }
  //           });
  //         }

  //       }
  //     }, err => {
  //       this.showloader = false;
  //     })
  //   } else {
  //     Swal.fire({
  //       icon: 'warning',
  //       title: 'Login Required',
  //       text: 'Please login to continue.',
  //       confirmButtonText: 'OK'
  //     });
  //   }

  // }
  gotoviewDetails(row) {
    console.log(row);

    this.router.navigate(['/companydetails'], {
      queryParams: {
        reqId: row.reqId
      }
    })

  }
}
